import { get, post } from "@/services/axiosUitils";

export interface RemainingTimeRequestItem {
  id: string;
  emp_id: string;
  emp_name: string;
  checkin: string;
  checkout: string | null;
  remaining_time: string;
  reason: string;
  date: string;
  not_filed_task?: boolean;
}

export interface RemainingTimeRequestResponse {
  status: boolean;
  message: string;
  count: number;
  page: number;
  page_size: number;
  links: {
    next: string | null;
    previous: string | null;
  };
  data: RemainingTimeRequestItem[];
}

interface RemainingTimeRequestParams {
  date: string;
  page?: number;
  page_size?: number;
}

export interface CreateRemainingTimeRequestPayload {
  emp_id: string;
  remaining_time: string;
  reason: string;
  date: string;
}

class PtsRemainingTimeRequestService {
  /**
   * Get remaining time requests for a given date.
   * Calls: /pts_app/remaining-time-request/?date=DD-MM-YYYY
   */
  getRemainingTimeRequests = async (
    params: RemainingTimeRequestParams
  ): Promise<RemainingTimeRequestResponse> => {
    return await get<RemainingTimeRequestResponse>(
      "/pts_app/remaining-time-request/",
      { params }
    );
  };

  /**
   * Create a remaining time request after spent hours submission.
   * Calls: POST /pts_app/remaining-time-request/
   */
  createRemainingTimeRequest = async (
    payload: CreateRemainingTimeRequestPayload
  ): Promise<any> => {
    return await post("/pts_app/remaining-time-request/", payload);
  };
}

const instance = new PtsRemainingTimeRequestService();
export default instance;
